export enum KVInputProfile {
  Default = 'Default',
  Switched = 'Switched',
  Creo = 'Creo',
}

export enum KVResolutionQuality {
  Low = 0.75,
  Standard = 1.0,
  High = 1.5,
}

export type KVUserSettingsJSON = {
  orbitSpeed: number
  fieldOfView: number
  inputProfile: string
  orbitCenterPersistent?: boolean
}

export class KVUserSettings {
  orbitSpeed: number
  fieldOfView: number
  inputProfile: KVInputProfile
  /** When the photo panel closes, restore orbit center persistent to this value. */
  orbitCenterPersistent: boolean

  constructor() {
    this.orbitSpeed = 0.7
    this.fieldOfView = 90
    this.inputProfile = KVInputProfile.Default
    this.orbitCenterPersistent = false
  }

  static fromJSON(json: KVUserSettingsJSON): KVUserSettings {
    const settings = new KVUserSettings()
    if (json.orbitSpeed) settings.orbitSpeed = json.orbitSpeed
    if (json.fieldOfView) settings.fieldOfView = json.fieldOfView
    if (json.inputProfile) {
      // Validate and convert string to enum
      if (
        Object.values(KVInputProfile).includes(
          json.inputProfile as KVInputProfile
        )
      ) {
        settings.inputProfile = json.inputProfile as KVInputProfile
      }
    }
    if (typeof json.orbitCenterPersistent === 'boolean') {
      settings.orbitCenterPersistent = json.orbitCenterPersistent
    }
    return settings
  }
}
